





























































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import AccountLendingBankSettings from '@/models/Accounts/LendingAccounts/Ledgers/Settings/Banking/AccountLendingBankSettings';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'AccountLendingBankSettingsRead' })
export default class extends SaascadaVueFieldGroup {

    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: AccountLendingBankSettings;

}
